import { useMemo } from "react";

export default function ParametrosSnapshotView({ parametrosSnapshotJson }) {

    const p = useMemo(() => {
        if (!parametrosSnapshotJson) return null;
        try {
            return JSON.parse(parametrosSnapshotJson);
        } catch {
            return null;
        }
    }, [parametrosSnapshotJson]);

    if (!p) return <div>Snapshot inválido</div>;

    return (
        <div className="grid grid-cols-1 md:grid-cols-6 gap-2">
            <div className="col-span-3">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-2 py-2">

                    <CardWrapper title="Configuração Geral" icon="fa fa-gear">
                        <Item label="Tipo Comissão" value={p.tipoComissao} bold />
                        <Item label="Dia de Fechamento" value={p.diaFechamento} />
                        <Item label="Máx Auxiliar por Carga" value={p.maxAuxiliarPorCarga} />
                    </CardWrapper>

                    <CardWrapper title="Descontos" icon="fa fa-minus-circle">
                        <Item label="Desconta Afastamentos" value={p.descontaAfastamentos ? "Sim" : "Não"} />
                        <Item label="Desconta Faltas" value={p.descontaFaltas ? "Sim" : "Não"} />
                    </CardWrapper>

                    <CardWrapper title="Regras de Cálculo" icon="fa fa-calculator">
                        <Item label="Calcula Cubagem" value={p.calculaCubagem ? "Sim" : "Não"} />
                        <Item label="Calcula Retorno Vendas" value={p.calculaRetornoVendas ? "Sim" : "Não"} />
                        <Item label="Calcula Conclusão Rota" value={p.calculaConclusaoRota ? "Sim" : "Não"} />
                        <Item label="Calcula Telemetria" value={p.calculaTelemetria ? "Sim" : "Não"} />
                    </CardWrapper>

                    <CardWrapper title="Conclusão de Rota" icon="fa fa-route">
                        <Item label="Percentual mínimo" value={`${p.percentualConclusao}%`} />
                        <Item label="Valor (1 Aux)" value={`R$ ${p.valorConclusaoCom1Auxiliar}`} />
                        <Item label="Valor (2 Aux)" value={`R$ ${p.valorConclusaoCom2Auxiliar}`} />
                    </CardWrapper>

                    <CardWrapper title="Proporcionalidade" icon="fa fa-balance-scale">
                        <Item label="Proporcional por Rota" value={p.aplicarProporcionalidadeRota ? "Sim" : "Não"} />
                        <Item label="Proporcional Telemetria" value={p.aplicarProporcionalidadeTelemetria ? "Sim" : "Não"} />
                        <Item label="Proporcional por Dias Trabalhados" value={p.aplicarProporcionalidadePorDiasTrabalhados ? "Sim" : "Não"} />
                    </CardWrapper>


                    <CardWrapper title="Tempos de Rotas" icon="fa fa-clock">
                        <Item label="24 horas (min)" value={p.minutosParaRotas24horas} />
                        <Item label="48 horas (min)" value={p.minutosParaRotas48horas} />
                        <Item label="72 horas (min)" value={p.minutosParaRotas72horas} />
                    </CardWrapper>
                </div>

            </div>
            <div className="col-span-3">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-2 py-2">

                    <CardWrapper title="Cubagem" icon="fa fa-cubes">
                        <Item label="Valor por Cubo (1 Aux)" value={`R$ ${p.valorPorCuboCom1Auxiliar}`} />
                        <Item label="Valor por Cubo (2 Aux)" value={`R$ ${p.valorPorCuboCom2Auxiliar}`} />
                        <Item label="Máx Cubo (1 Aux)" value={`R$ ${p.valorMaximoPorCuboCom1Auxiliar}`} />
                        <Item label="Máx Cubo (2 Aux)" value={`R$ ${p.valorMaximoPorCuboCom2Auxiliar}`} />
                    </CardWrapper>

                    <CardWrapper title="Telemetria" icon="fa fa-shield">
                        <Item label="Percentual Mínimo (Meta)" value={`R$ ${p.metaTelemetria || '/'}`} />
                        <Item label="Valor (1 Aux)" value={`R$ ${p.valorTelemetriaCom1Auxiliar || '/'}`} />
                        <Item label="Valor (2 Aux)" value={`R$ ${p.valorTelemetriaCom2Auxiliar || '/'}`} />
                        <Item label="Aplica Proporcionalidade " value={`${p.valorTelemetriaSemProporcao || '/'}`} />
                    </CardWrapper>
                    <div className="col-span-2">
                        <CardWrapper title="Retorno de Vendas" icon="fa fa-undo">

                            <Item
                                label="Limite Máximo"
                                value={`${p.limiteMaximoPercentualRetorno}%`}
                                bold
                            />

                            <div className="mt-2 overflow-x-auto">
                                <table className="w-full text-xs border border-border rounded-lg overflow-hidden">
                                    <thead className="bg-muted">
                                        <tr>
                                            <th className="text-left px-2 py-1">Faixa</th>
                                            <th className="text-right px-2 py-1">Limite %</th>
                                            <th className="text-right px-2 py-1">1 Aux</th>
                                            <th className="text-right px-2 py-1">2 Aux</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr className="border-t border-border">
                                            <td className="px-2 py-1">Faixa 1</td>
                                            <td className="text-right px-2 py-1">{p.retornoFaixa1Limite}%</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa1Valor1Aux}</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa1Valor2Aux}</td>
                                        </tr>

                                        <tr className="border-t border-border">
                                            <td className="px-2 py-1">Faixa 2</td>
                                            <td className="text-right px-2 py-1">{p.retornoFaixa2Limite}%</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa2Valor1Aux}</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa2Valor2Aux}</td>
                                        </tr>

                                        <tr className="border-t border-border">
                                            <td className="px-2 py-1">Faixa 3</td>
                                            <td className="text-right px-2 py-1">{p.retornoFaixa3Limite}%</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa3Valor1Aux}</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa3Valor2Aux}</td>
                                        </tr>

                                        <tr className="border-t border-border">
                                            <td className="px-2 py-1">Faixa 4</td>
                                            <td className="text-right px-2 py-1">{p.retornoFaixa4Limite}%</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa4Valor1Aux}</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa4Valor2Aux}</td>
                                        </tr>

                                        <tr className="border-t border-border">
                                            <td className="px-2 py-1">Faixa 5</td>
                                            <td className="text-right px-2 py-1">{p.limiteMaximoPercentualRetorno}</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa5Valor1Aux}</td>
                                            <td className="text-right px-2 py-1">R$ {p.retornoFaixa5Valor2Aux}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </CardWrapper>
                    </div>
                </div>
            </div>
        </div>
    );
}

function CardWrapper({ title, icon, children }) {
    return (
        <div className="rounded-xl border border-border bg-card p-3 shadow-card">
            <h4 className="font-semibold text-sm mb-3 flex items-center gap-2 justify-between">
                <div className="flex items-center gap-2">

                    <i className={`${icon} text-teal-600`} />
                    {title}
                </div>
            </h4>
            <div className="space-y-1.5 text-xs text-muted-foreground">
                {children}
            </div>
        </div>
    );
}

function Item({ label, value, bold }) {
    return (
        <div className="flex justify-between">
            <span>{label}</span>
            <span className={bold ? "font-bold text-foreground" : "font-medium text-foreground"}>
                {value}
            </span>
        </div>
    );
}